<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex xs12 class="text-xs-center" mt-5>
                <h1>{{this.$t('subscribe_to_section_title')}}</h1>
            </v-flex>
            <v-flex xs12 sm6 offset-sm3 mt-3>
                <div>
                    <p class="error">{{ error }}</p>
                    <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit">
                    <div v-if="subscriptionSuccess" class="subscription-success">
                        {{this.$t('subscription_success_message')}}
                    </div>

                    <div v-if="subscriptionFailure" class="subscription-failure">
                        {{subscriptionFailureError}}
                    </div>

                    <div v-if="subscriptionPending" class="subscription-pending">
                        {{this.$t('subscription_pending_message')}}
                    </div>
                    </qrcode-stream>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import { QrcodeStream } from 'vue-qrcode-reader'
    import DeviceService from "../apiServices/DeviceService";

    export default {
        name: "SubscribeTo",
        components: {QrcodeStream},
        data(){
            return {
                error: '',
                isValid: undefined,
                camera: 'auto',
                subscriptionFailureError: ''
            }
        },
        methods: {
            async onInit (promise) {
                try {
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.error = this.$t('NotAllowedError_message')
                    } else if (error.name === 'NotFoundError') {
                        this.error = this.$t('NotFoundError_message')
                    } else if (error.name === 'NotSupportedError') {
                        this.error = this.$t('NotSupportedError_message')
                    } else if (error.name === 'NotReadableError') {
                        this.error = this.$t('NotReadableError_message')
                    } else if (error.name === 'OverconstrainedError') {
                        this.error = this.$t('OverconstrainedError_message')
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.error = this.$t('StreamApiNotSupportedError_message')
                    }
                    this.resetValidationState()
                }
            },
            resetValidationState () {
                this.isValid = undefined
            },

            async onDecode (content) {
                this.turnCameraOff()

                //Validation
                if(/^[a-zA-Z0-9_-]+(\?subscriptionCode=[A-Fa-f0-9]{64})?$/.test(content)){
                    //It is valid, send to server
                    await DeviceService.subscribeTo(content).then(() =>{
                        this.isValid = true
                    }).catch(() => {
                        this.subscriptionFailureError = this.$t('general_subscription_error_message')
                        this.isValid = false
                    })
                }else{
                    this.subscriptionFailureError = this.$t('not_valid_subscription_code_error_message')
                    this.isValid = false;
                }

                // some more delay, so users have time to read the message
                await this.timeout(2000)
                this.resetValidationState()
                this.turnCameraOn()
            },

            turnCameraOn () {
                this.camera = 'auto'
            },

            turnCameraOff () {
                this.camera = 'off'
            },

            timeout (ms) {
                return new Promise(resolve => {
                    window.setTimeout(resolve, ms)
                })
            }
        },
        computed: {
            subscriptionPending () {
                return this.isValid === undefined
                    && this.camera === 'off'
            },

            subscriptionSuccess () {
                return this.isValid === true
            },

            subscriptionFailure () {
                return this.isValid === false
            }
        }
    }
</script>

<style scoped>
    .subscription-success,
    .subscription-failure,
    .subscription-pending {
        position: absolute;
        width: 100%;
        height: 100%;

        background-color: rgba(255, 255, 255, .8);
        text-align: center;
        font-weight: bold;
        font-size: 1.4rem;
        padding: 10px;

        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
    }
    .subscription-success {
        color: green;
    }
    .subscription-failure {
        color: red;
    }
</style>

<i18n>
    {
        "en": {
            "subscribe_to_section_title": "Subscribe to a device",
            "subscription_success_message": "Subscribed successfully!!",
            "subscription_pending_message": "Subscription in progress...",
            "general_subscription_error_message": "Error to subscribe",
            "not_valid_subscription_code_error_message": "Not is a Subscription Code valid",
            "NotAllowedError_message": "ERROR: you need to grant camera access permission",
            "NotFoundError_message": "ERROR: no camera on this device",
            "NotSupportedError_message": "ERROR: secure context required (HTTPS, localhost)",
            "NotReadableError_message": "ERROR: is the camera already in use?",
            "OverconstrainedError_message": "ERROR: installed cameras are not suitable",
            "StreamApiNotSupportedError_message": "ERROR: Stream API is not supported in this browser"
        },
        "es": {
            "subscribe_to_section_title": "Suscribir a un dispositivo",
            "subscription_success_message": "Suscrito exitosamente!!",
            "subscription_pending_message": "Suscripción en curso...",
            "general_subscription_error_message": "Error al suscribirse",
            "not_valid_subscription_code_error_message": "No es un código de suscripción válido",
            "NotAllowedError_message": "ERROR: es necesario conceder permiso de acceso a la cámara",
            "NotFoundError_message": "ERROR: no hay cámaras en este dispositivo",
            "NotSupportedError_message": "ERROR: se requiere contexto seguro (HTTPS, localhost)",
            "NotReadableError_message": "ERROR: ¿la cámara ya está en uso?",
            "OverconstrainedError_message": "ERROR: las cámaras instaladas no son adecuadas",
            "StreamApiNotSupportedError_message": " ERROR: Stream API no es compatible con este navegador"
        }
    }
</i18n>
